import type { QueueJobRow } from "@/admin/entities/queues";
import type { QueueJobsListQueryQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: QueueJobRow[];
  count: number;
} {
  const queue = (data as QueueJobsListQueryQueryType)?.queue;
  if (!queue?.jobs?.nodes) {
    return { nodes: [], count: 0 };
  }
  return queue.jobs;
}

export function mapColumns(job: QueueJobRow) {
  return [
    job.id,
    job.name,
    [job.steps, job.progress, job.state],
    job.state,
    job.attemptsMade,
    job.failedReason,
    [job.finishedOn, job.processedOn],
    [job.processedOn, job.timestamp],
    job.timestamp,
    job.finishedOn,
    job.processedOn,
    [job.id, job.state],
  ];
}

/**
 * Длительность между двумя метками времени в виде `ч:мм:сс` / `м:сс` / `с`
 * (в референсе тем же занят moment-duration-format).
 */
export function formatDuration(to?: string | null, from?: string | null) {
  if (!to || !from) return null;

  const ms = new Date(to).getTime() - new Date(from).getTime();
  if (!Number.isFinite(ms) || ms < 0) return null;

  const totalSeconds = Math.floor(ms / 1000);
  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);

  const pad = (value: number) => String(value).padStart(2, "0");

  if (hours > 0) return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  if (minutes > 0) return `${minutes}:${pad(seconds)}`;
  return String(seconds);
}
